import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface Props {
  children: React.ReactNode;
  gameName?: string;
}

interface State {
  hasError: boolean;
}

export default class GameErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error(`[2Players] Game crash in ${this.props.gameName || 'unknown'}:`, error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center p-12 text-center">
          <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
          <h3 className="text-xl font-bold text-white mb-2">Game Crashed</h3>
          <p className="text-gray-300 mb-6">
            Something went wrong with {this.props.gameName || 'the game'}. Your progress may be lost.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-600 to-violet-600 rounded-lg hover:opacity-90 transition"
          >
            <RefreshCw className="w-5 h-5" />
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
